import { render, staticRenderFns } from "./newsDetails.vue?vue&type=template&id=7d957b1f&scoped=true"
import script from "./newsDetails.vue?vue&type=script&lang=js"
export * from "./newsDetails.vue?vue&type=script&lang=js"
import style0 from "./newsDetails.vue?vue&type=style&index=0&id=7d957b1f&prod&lang=scss&scoped=true"
import style1 from "./newsDetails.vue?vue&type=style&index=1&id=7d957b1f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d957b1f",
  null
  
)

export default component.exports